// This is manually calculated, used for sticky sidebars
export const layoutHeaderDesktopHeightWithSearchBar = 140;
export const layoutHeaderDesktopHeightWithSearchBarAndFilters = 210;
